import i18next from "i18next";
import { IoChatbubblesOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../context/auth";

import { SupportButton, Wrapper } from "./style";

// Кнопка «Написать в поддержку» на странице заказа (рядом с возвратом).
// Гостю передаём и email плательщика — форма доступа к заявкам заполнится сама.
const OrderSupportComponent = ({ isShowInSmallScreen = false }) => {
  const { t } = i18next;
  const navigate = useNavigate();
  const { isAuth } = useAuth();
  const { orderData } = useSelector(state => state.order);

  const orderId = orderData?.order_id;

  if (!orderId) return null;

  const handleClick = () => {
    const params = new URLSearchParams({ order_id: orderId });
    if (!isAuth && orderData?.payer_email) params.set("email", orderData.payer_email);
    navigate(`/support?${params.toString()}`);
  };

  return (
    <Wrapper $isShowInSmallScreen={isShowInSmallScreen}>
      <SupportButton type="button" onClick={handleClick}>
        <IoChatbubblesOutline />
        {t("support_write")}
      </SupportButton>
    </Wrapper>
  );
};

export default OrderSupportComponent;
